import { Component, OnInit, HostListener } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import * as bath from 'thai-baht-text';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-print-bill-3x4',
  templateUrl: './print-bill-3x4.component.html',
  styleUrls: ['./print-bill-3x4.component.scss']
})
export class PrintBillComponent_3X4 implements OnInit {
  @HostListener('window:afterprint', ['$event'])
  public afterPrintHandler(event) {
    window.close();
    window.stop();
    console.log('Printing finished or canceled.ๅๅๅ');
  }
  bill_id = '';
  customer_id = '';
  customer_name = '';
  place_description = '';
  place_address = '';
  place_id = '';
  fee_id = '';
  pay_datetime = '';
  invoice_id = '';

  total_price = '';
  discount = null;
  user = '';
  total_price_bath = '';
  fee_description1 = '';
  fee_count1 = '';
  price1 = '';
  fee_description2 = ' ';
  fee_count2 = ' ';
  price2 = ' ';
  fee_description3 = ' ';
  fee_count3 = ' ';
  price3 = ' ';
  fee_description4 = ' ';
  fee_count4 = ' ';
  price4 = ' ';
  fee_description5 = ' ';
  fee_count5 = ' ';
  price5 = ' ';
  fee_description6 = ' ';
  fee_count6 = ' ';
  price6 = ' ';
  fee_description7 = ' ';
  fee_count7 = ' ';
  price7 = ' ';
  fee_description8 = ' ';
  fee_count8 = ' ';
  price8 = ' ';
  fee_description9 = ' ';
  fee_count9 = ' ';
  price9 = ' ';
  fee_description10 = ' ';
  fee_count10 = ' ';
  price10 = ' ';
  fee_description11 = ' ';
  fee_count11 = ' ';
  price11 = ' ';
  fee_description12 = ' ';
  fee_count12 = ' ';
  price12 = ' ';
  isLoading = true;
  base64_img_muni = null;
  img_src = null;
  fee_type_description = null;
  fee_price = null;
  fee_date = null;
  fullname = null;
  barcode_cus_place = null;
  payment_description = null;
  barcode_bill = null;
  municipality = null;
  place_owner = null;
  sum_price = 0;
  data_new = null;
  end_sum = null;
  constructor(private route: ActivatedRoute, router: Router, private service: MyserviceService, private sanitizer: DomSanitizer) { };
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      //debugger
      this.bill_id = params['bill_id'];
    });

    this.refresh();
    this.municipality = JSON.parse(sessionStorage.getItem('municipality'))
    this.base64_img_muni = `data:image/png;base64,${this.municipality.icon_img}`
    this.img_src = this.sanitizer.bypassSecurityTrustUrl(this.base64_img_muni);
  }

  refresh() {
    var formatter = new Intl.NumberFormat('th-TH', {
      style: 'currency',
      currency: 'THB',
    });
    let month_th = '';
    this.isLoading = true;
    this.service.postData({ bill_id: this.bill_id }, "bill/get-bill-invoice").then((result: any) => {
      //debugger
      console.log(result);
      this.isLoading = false;
      console.log(result.data);
      if (!result.code) {
        if (result.data.length > 0) {

          let length_bill = 0;
          if (result.data.length <= 12) {
            length_bill = result.data.length;
          }
          else {
            length_bill = 12;
          }
          for (let i = 0; i < result.data.length; i++) {
            const q = result.data[i];
            this.sum_price += parseInt(q.fee_price)
          }
          this.end_sum = formatter.format(this.sum_price)
          this.data_new = result.data.map((e: any) => {

            let fee_description;

            switch (moment(e.fee_date).format("MM")) {
              case '01':
                fee_description = e.fee_description + ' (มกราคม)';
                break;
              case '02':
                fee_description = e.fee_description + ' (กุมภาพันธ์)';
                break;
              case '03':
                fee_description = e.fee_description + ' (มีนาคม)';
                break;
              case '04':
                fee_description = e.fee_description + ' (เมษายน)';
                break;
              case '05':
                fee_description = e.fee_description + ' (พฤษภาคม)';
                break;
              case '06':
                fee_description = e.fee_description + ' (มิถุนายน)';
                break;
              case '07':
                fee_description = e.fee_description + ' (กรกฏาคม)';
                break;
              case '08':
                fee_description = e.fee_description + ' (สิงหาคม)';
                break;
              case '09':
                fee_description = e.fee_description + ' (กันยายน)';
                break;
              case '10':
                fee_description = e.fee_description + ' (ตุลาคม)';
                break;
              case '11':
                fee_description = e.fee_description + ' (พฤศจิกายน)';
                break;
              case '12':
                fee_description = e.fee_description + ' (ธันวาคม)';
                break;
            }
            return {
              barcode_bill: e.bill_id,
              barcode_cus_place: e.customer_id + ' ' + e.place_id,
              discount: formatter.format(e.discount),
              customer_id: e.customer_id,
              customer_name: e.customer_name + " " + e.customer_surname,
              place_id: e.place_id,
              place_address: e.place_address,
              place_description: e.place_description,
              payment_description: e.payment_description,
              fee_id: e.fee_id,
              tambon_th: e.tambon_th,
              postcode: e.postcode,
              amphur_th: e.amphur_th,
              province_th: e.province_th,
              bill_id: e.bill_id,
              mobile: e.mobile,
              block_id: e.block_id,
              fee_description: fee_description,
              fee_type_description: e.fee_type_description,
              zone_name: e.zone_name,
              fee_price: formatter.format(e.fee_price),
              place_owner: e.place_owner,
              pay_datetime: moment(e.pay_datetime).add(543, 'year').format("DD/MM/YYYY HH:mm:ss"),
              fee_date: moment(e.fee_date).add(543, 'year').format("DD/MM/YYYY HH:mm:ss"),
              invoice_id: e.invoice_id,
              total_price: formatter.format(e.total_price),
              total_price_bath: bath(e.total_price),
            }

          })
          // for (let x = 0; x <= length_bill - 1; x++) {

          //   switch (moment(result.data[x].due_date).format("MM")) {
          //     case '01':
          //       month_th = ' (มกราคม)';
          //       break
          //     case '02':
          //       month_th = ' (กุมภาพันธ์)';
          //       break
          //     case '03':
          //       month_th = ' (มีนาคม)';
          //       break
          //     case '04':
          //       month_th = ' (เมษายน)';
          //       break
          //     case '05':
          //       month_th = ' (พฤษภาคม)';
          //       break
          //     case '06':
          //       month_th = ' (มิถุนายน)';
          //       break
          //     case '07':
          //       month_th = ' (กรกฏาคม)';
          //       break
          //     case '08':
          //       month_th = ' (สิงหาคม)';
          //       break
          //     case '09':
          //       month_th = ' (กันยายน)';
          //       break
          //     case '10':
          //       month_th = ' (ตุลาคม)';
          //       break
          //     case '11':
          //       month_th = ' (พฤศจิกายน)';
          //       break
          //     case '12':
          //       month_th = ' (ธันวาคม)';
          //       break
          //   }

          //   switch (x) {
          //     case 0:
          //       result.data[x].fee_description = result.data[x].fee_description + month_th;
          //       this.fee_description1 = result.data[x].fee_description;
          //       this.fee_count1 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
          //       this.price1 = formatter.format(result.data[x].total_price);
          //       break;
          //     case 1:
          //       result.data[x].fee_description = result.data[x].fee_description + month_th;
          //       this.fee_description2 = result.data[x].fee_description;
          //       this.fee_count2 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
          //       this.price2 = formatter.format(result.data[x].total_price);
          //       break;
          //     case 2:
          //       result.data[x].fee_description = result.data[x].fee_description + month_th;
          //       this.fee_description3 = result.data[x].fee_description;
          //       this.fee_count3 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
          //       this.price3 = formatter.format(result.data[x].total_price);
          //       break;
          //     case 3:
          //       result.data[x].fee_description = result.data[x].fee_description + month_th;
          //       this.fee_description4 = result.data[x].fee_description;
          //       this.fee_count4 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
          //       this.price4 = formatter.format(result.data[x].total_price);
          //       break;
          //     case 4:
          //       result.data[x].fee_description = result.data[x].fee_description + month_th;
          //       this.fee_description5 = result.data[x].fee_description;
          //       this.fee_count5 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
          //       this.price5 = formatter.format(result.data[x].total_price);
          //       break;
          //     case 5:
          //       result.data[x].fee_description = result.data[x].fee_description + month_th;
          //       this.fee_description6 = result.data[x].fee_description;
          //       this.fee_count6 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
          //       this.price6 = formatter.format(result.data[x].total_price);
          //       break;
          //     case 6:
          //       result.data[x].fee_description = result.data[x].fee_description + month_th;
          //       this.fee_description7 = result.data[x].fee_description;
          //       this.fee_count7 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
          //       this.price7 = formatter.format(result.data[x].total_price);
          //       break;
          //     case 7:
          //       result.data[x].fee_description = result.data[x].fee_description + month_th;
          //       this.fee_description8 = result.data[x].fee_description;
          //       this.fee_count8 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
          //       this.price8 = formatter.format(result.data[x].total_price);
          //       break;
          //     case 8:
          //       result.data[x].fee_description = result.data[x].fee_description + month_th;
          //       this.fee_description9 = result.data[x].fee_description;
          //       this.fee_count9 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
          //       this.price9 = formatter.format(result.data[x].total_price);
          //       break;
          //     case 9:
          //       result.data[x].fee_description = result.data[x].fee_description + month_th;
          //       this.fee_description10 = result.data[x].fee_description;
          //       this.fee_count10 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
          //       this.price10 = formatter.format(result.data[x].total_price);
          //       break;
          //     case 10:
          //       result.data[x].fee_description = result.data[x].fee_description + month_th;
          //       this.fee_description11 = result.data[x].fee_description;
          //       this.fee_count11 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
          //       this.price11 = formatter.format(result.data[x].total_price);
          //       break;
          //     case 11:
          //       result.data[x].fee_description = result.data[x].fee_description + month_th;
          //       this.fee_description12 = result.data[x].fee_description;
          //       this.fee_count12 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
          //       this.price12 = formatter.format(result.data[x].total_price);
          //       break;
          //   }
          // }
          console.log(this.data_new);
          var xy = 0;
          xy = parseInt(moment(result.data[0].pay_datetime).format('YYYY'));

          if (xy < 2500) {
            xy = xy + 543;
          }

          this.service.postData({ user_id: result.data[0].user_id }, "user-location/get-user-detail").then((result2: any) => {
            if (!result2.code) {
              console.log(result2);
              if (result2.data.length > 0) {

                this.user = result2.data[0].user_name;
                this.fullname = result2.data[0].user_name + ' ' + result2.data[0].user_surname;
                setTimeout(() => {
                  window.print();
                }, 1000);
              } else {
                this.user = result2.data[0].user_id;
                setTimeout(() => {
                  window.print();
                }, 1000);
              }
            }
            else {
              Swal.fire({
                title: result.message,
                text: '',
                type: 'error',
                showCancelButton: false,
                showConfirmButton: false,
                timer: 2000
              });
            }

          })

        }

      }
      else {
        Swal.fire({
          title: result.message,
          text: '',
          type: 'error',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 2000
        })
      }

    })
  }
}
